"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _react = _interopRequireWildcard(require("react"));

var Charts = function Charts(props) {
  var _React$createElement;

  return _react["default"].createElement("svg", (_React$createElement = {
    className: props.className,
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg"
  }, _React$createElement["xmlns"] = "http://www.w3.org/1999/xlink", _React$createElement.role = "img", _React$createElement), _react["default"].createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, _react["default"].createElement("g", {
    transform: "translate(1.000000, 1.000000)"
  }, _react["default"].createElement("path", {
    d: "M13.9995,0.0003 C6.2805,0.0003 -0.0005,6.2803 -0.0005,14.0003 C-0.0005,21.7193 6.2805,28.0003 13.9995,28.0003 C21.7195,28.0003 27.9995,21.7193 27.9995,14.0003 C27.9995,6.2803 21.7195,0.0003 13.9995,0.0003",
    fill: "#002272"
  }), _react["default"].createElement("path", {
    className: "hvr-icon-fill",
    d: "M21.8945,9.4473 L16.8945,19.4473 C16.7245,19.7873 16.3775,20.0003 15.9995,20.0003 C15.9865,20.0003 15.9725,20.0003 15.9575,19.9993 C15.5655,19.9823 15.2175,19.7373 15.0715,19.3713 L11.8035,11.2013 L7.8475,17.5303 C7.5555,17.9993 6.9385,18.1413 6.4695,17.8473 C6.0015,17.5553 5.8595,16.9383 6.1525,16.4693 L11.1525,8.4693 C11.3515,8.1503 11.7085,7.9643 12.0885,8.0043 C12.4635,8.0373 12.7895,8.2793 12.9285,8.6293 L16.1015,16.5603 L20.1055,8.5523 C20.3535,8.0583 20.9545,7.8593 21.4475,8.1053 C21.9415,8.3523 22.1415,8.9533 21.8945,9.4473",
    fill: "#FFFFFF"
  }))));
};

var _default = Charts;
exports["default"] = _default;